import type { ServiceOfferVariant } from "@/convex/crm/serviceCatalogShared";
import { createContext, useContext } from "react";
import type { BuyerInput } from "@/pages/services/_components/agreement-review-dialog";

export type ServiceComboItem = {
  serviceKey: string;
  offerVariant: ServiceOfferVariant;
  label: string;
  setupAmount?: number;
  monthlyAmount?: number;
  recurringMonths?: number;
  voucherCode?: string;
};

export type ServiceCommerceContextValue = {
  items: ServiceComboItem[];
  addItem: (item: ServiceComboItem) => void;
  removeItem: (serviceKey: string, offerVariant: ServiceOfferVariant) => void;
  clear: () => void;
  open: boolean;
  setOpen: (open: boolean) => void;
  balanceMicrochips: number;
  checkout: (rewardMicrochips: number, locale: string, agreementPreviewSha256: string, buyer: BuyerInput, selection?: ServiceComboItem[]) => Promise<void>;
  checkoutLoading: boolean;
};

export const ServiceCommerceContext =
  createContext<ServiceCommerceContextValue | null>(null);

export function useServiceCommerce() {
  const value = useContext(ServiceCommerceContext);
  if (!value) {
    throw new Error("useServiceCommerce must be used inside ServiceCommerceProvider");
  }
  return value;
}
